import angular from 'angular';
import template from './mobile-doctor-actions.html';
class OneToOneMobileDoctorActionsController {
    constructor() { }
    $onInit() { }
}
const oneToOneMobileDoctorActions = {
    template,
    bindings: {
        onToggleAudio: '&',
        hasAudio: '&',
        activeVideoProvider: '<',
    },
    controller: OneToOneMobileDoctorActionsController,
};
export default angular
    .module('doxy.videoChat.callFrames.selfVideoFrame.selfVideoFrameFull.actions.oneToOne.mobileDoctorActions', [])
    // one-to-one-mobile-doctor-actions
    .component('oneToOneMobileDoctorActions', oneToOneMobileDoctorActions).name;
